export const formatNumberToPrice = (q: string | number): string => q?.toLocaleString('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});
